import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";
import { ErrorBanner } from "../components/ui";
import { BrandLockup } from "../components/BrandLockup";
import { privacyDoc as PrivacyDoc } from "../legal";

// 新規会員登録 (公開)。登録後は管理者の承認待ち (approval_status=pending) となり、
// 承認されるまでログインできない。
export function RegisterPage() {
  const [email, setEmail] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  return (
    <div className="min-h-screen flex flex-col bg-tora-paper">
      <header className="bg-white border-b-2 border-tora-accent">
        <div className="mx-auto max-w-7xl px-4 py-3">
          <BrandLockup />
        </div>
      </header>

      <main className="flex-1 flex flex-col items-center justify-center px-4 py-10">
        {done ? (
          <div className="card w-full max-w-md p-6 md:p-8 shadow-md text-center">
            <h1 className="text-2xl font-bold text-tora-ink">登録を受け付けました</h1>
            <p className="text-sm text-tora-ink/70 mt-3 leading-relaxed">
              ご登録ありがとうございます。<br />
              内容を管理者が確認し、<b>承認後にログイン</b>いただけるようになります。
              承認まで今しばらくお待ちください。
            </p>
            <p className="mt-6">
              <Link to="/login" className="btn-primary btn-lg w-full inline-block">
                ログイン画面へ
              </Link>
            </p>
          </div>
        ) : (
          <form
            className="card w-full max-w-md p-6 md:p-8 shadow-md"
            onSubmit={async (e) => {
              e.preventDefault();
              setErr(null);
              if (password !== password2) {
                setErr("パスワードが一致しません");
                return;
              }
              setBusy(true);
              try {
                await api.post("/auth/register", {
                  email,
                  password,
                  displayName,
                });
                setDone(true);
              } catch (e) {
                setErr((e as Error).message ?? "登録に失敗しました");
              } finally {
                setBusy(false);
              }
            }}
          >
            <p className="text-[11px] text-tora tracking-widest font-semibold">
              MEMBER SIGN UP
            </p>
            <h1 className="text-2xl md:text-3xl font-bold text-tora-ink mt-1.5">
              新規会員登録
            </h1>
            <p className="text-sm text-tora-ink/70 mt-1 mb-6">
              登録後、管理者の承認を経てご利用いただけます。
            </p>

            <div className="mb-4">
              <label className="label" htmlFor="displayName">
                お名前（表示名）
              </label>
              <input
                id="displayName"
                type="text"
                className="input"
                value={displayName}
                onChange={(e) => setDisplayName(e.target.value)}
                required
                maxLength={100}
                autoFocus
                placeholder="例: 山田 太郎"
              />
            </div>
            <div className="mb-4">
              <label className="label" htmlFor="email">
                メールアドレス
              </label>
              <input
                id="email"
                type="email"
                className="input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                autoCapitalize="off"
                autoCorrect="off"
                spellCheck={false}
                inputMode="email"
                placeholder="例: yamada@example.com"
              />
            </div>
            <div className="mb-4">
              <label className="label" htmlFor="password">
                パスワード（8文字以上）
              </label>
              <input
                id="password"
                type="password"
                className="input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={8}
                autoComplete="new-password"
              />
            </div>
            <div className="mb-4">
              <label className="label" htmlFor="password2">
                パスワード（確認）
              </label>
              <input
                id="password2"
                type="password"
                className="input"
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
                required
                minLength={8}
                autoComplete="new-password"
              />
            </div>
            {err && <ErrorBanner className="mb-3">{err}</ErrorBanner>}
            <button className="btn-primary btn-lg w-full" disabled={busy}>
              {busy ? "登録中…" : "登録する →"}
            </button>
            <p className="mt-5 text-center">
              <Link to="/login" className="tap-target text-sm text-tora hover:underline">
                すでに登録済みの方はログイン
              </Link>
            </p>
          </form>
        )}
        {/* 規約・方針は登録前に読めるべきものなので、ここから開けるようにする。
           個人情報保護方針を持たないブランドではリンクを出さない */}
        <p className="mt-6 text-center text-xs text-tora-ink/50 flex items-center justify-center gap-3">
          <Link to="/terms" className="hover:text-tora hover:underline">利用規約</Link>
          {PrivacyDoc && (
            <Link to="/privacy" className="hover:text-tora hover:underline">個人情報保護方針</Link>
          )}
        </p>
      </main>
    </div>
  );
}
